import styled from 'styled-components';

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 16px;
`

export default FormContainer;